import React from "react";
import { PRODUCT_INTERESTS } from "@/lib/applyForm";

export const Step3 = ({ data, onChange, errors }) => {
  const toggle = (value) => {
    const set = new Set(data);
    if (set.has(value)) set.delete(value);
    else set.add(value);
    onChange(Array.from(set));
  };

  return (
    <div data-testid="apply-step-3" className="space-y-4">
      <p className="text-sm text-lw-muted leading-relaxed max-w-xl">
        Pick anything you're curious about — your advisor will narrow it down
        in the consultation. No commitment to any product on this list.
      </p>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
        {PRODUCT_INTERESTS.map((p) => {
          const selected = data.includes(p.value);
          return (
            <button
              type="button"
              key={p.value}
              onClick={() => toggle(p.value)}
              data-testid={`apply-interest-${p.value}`}
              className={`flex items-start gap-3 px-4 py-3.5 rounded-xl border text-left transition-all ${
                selected
                  ? "border-lw-gold bg-lw-gold/10 shadow-sm"
                  : "border-lw-navy/15 bg-white hover:border-lw-navy/30"
              }`}
            >
              <span
                className={`mt-0.5 flex items-center justify-center w-5 h-5 rounded-md border ${
                  selected
                    ? "bg-lw-gold border-lw-gold"
                    : "border-lw-navy/30 bg-white"
                }`}
                aria-hidden="true"
              >
                {selected && (
                  <svg
                    width="12"
                    height="12"
                    viewBox="0 0 12 12"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M2 6L5 9L10 3"
                      stroke="#0B2545"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                )}
              </span>
              <span className="font-sans-ui text-sm text-lw-navy font-medium">
                {p.label}
              </span>
            </button>
          );
        })}
      </div>
      {errors.product_interests && (
        <span className="block text-xs text-red-600">
          {errors.product_interests}
        </span>
      )}
    </div>
  );
};

export default Step3;
